import {FDSPhase} from '@web/core/constants'

import {FDSStatus} from '../constants'
import {FdsState} from '../interfaces'

export const getInitialState = (): FdsState => ({
    /** fds uuid */
    uuid: null,
    /** fds process phase */
    phase: FDSPhase.INACTIVE,
    /** fds processing status */
    status: FDSStatus.PENDING,
    /** fds 인증 정보 */
    authentication: null,
    /** fds 옵션 */
    options: {
        ignoreUuid: false,
    },
    /** fds 실패 이유 */
    rejectionReason: null,
})
